export enum MessageRole {
  system = 'system',
    user = 'user',
    assistant = 'assistant',
}

export type MessageType = {
  content: string;
  role: MessageRole;
  id: string;
  isCopy ? : boolean;
  chippyDisabled ? : boolean;
  isInstruction ? : boolean;
};

export type AIRequestPayload = {
  messages: MessageType[];
  userModel ? : string;
}

export type AIPageRequestPayload = {
  messages: MessageType[];
  context: string;
  userModel ? : string;
  thread ? : Thread;
  messageToken: string;
}


export type AISuggestionRequestPayload = {
  url: string;
  title: string;
  description: string;
  messageToken: string;
}

export type QuestionsType = {
  questions: Array < string > ;
  relevancy: 'high' | 'medium' | 'low';
  subject: string;
};

export type UserInfo = {
  email: string;
  family_name: string;
  given_name: string;
  hd ? : string;
  sub: string;
  language: string;
  locale: string;
  picture: string;
  name: string;
  verified_email: boolean;
};

export type UserMetricsType = {
  dailyMessages: number;
  dailyMessagesGPT4: number;
  maxMessages: number;
  maxMessagesGPT4: number;
  isFree: boolean;
  openedDaily: number;
  pageQueryUsed: boolean;
}

export type UserType = {
  profile ? : UserInfo;
  id: string;
  isFree: boolean;
  messagesToken: string;
};

export type EmailRequestPayload = {
  thread: Thread;
}

export type SimplifiedEmail = {
  content_html: string;
  from: {
    address: string;
    name: string;
  };
  to: {
    address: string;
    name: string;
  } [];
  cc: {
    address: string;
    name: string;
  } [];
  date: string;
}

export type Thread = {
  subject: string;
  emails: SimplifiedEmail[];
  userEmail: string;
}

export enum UserStatus {
  onboarding = 'onboarding',
  theme = 'theme',
  complete = 'complete',
}